// extracted by mini-css-extract-plugin
export default {"wrapper":"adList-module--wrapper--2DaRN","text":"adList-module--text--L3-r2","cardMargin":"adList-module--cardMargin--znziU"};